<template>
  <div class="assessmentContainer">
    <header-assessment></header-assessment>
    <div class="assessmentContent">

      <header class="sectionHeader">
        <div class="sectionHeader-description">
          <!-- NO AREAS OF CONCERN -->
          <span v-if="lead.areasOfConcern.length < 1">Let’s talk about an area of concern.</span>
          <!-- ONE AREA OF CONCERN -->
          <span v-if="lead.areasOfConcern.length === 1">
            Great! We'll take a look at the {{ lead.areasOfConcern[0].name }}
          </span>
          <!-- MULTIPLE AREAS OF CONCERN -->
          <span v-if="lead.areasOfConcern.length > 1">Your areas of concern</span>
        </div>
      </header>

      <!-- List all areas of concern that have been added -->
      <section class="areasOfConcern-section" v-if="lead.areasOfConcern.length > 0">
        <div class="areasOfConcern">
          <!-- <div class="areasOfConcern-title">Areas of concern</div> -->
          <div class="areaOfConcern content-box" v-for="areaOfConcern in lead.areasOfConcern">
            <div class="content-box-inner thin">
              {{ areaOfConcern.name }}
            </div>
          </div>
        </div>
      </section>

      <section class="sectionBody">

        <!-- IF At LEAST ONE AOC, PROMPT TO ADD ANOTHER -->
        <header class="sectionHeader" v-if="lead.areasOfConcern.length > 0">
          <div class="sectionHeader-description">
            Have anymore points of entry?
          </div>
        </header>

        
      </section>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  data() {
    return {
      value: null,
      roomDefault: {},
      room: {
        name: '',
        windows: 0,
        windowsInput: null,
        windowsThatOpen: 0,
        windowsThatOpenInput: null,
      },
      windowOptions: [
        {label: 1, value: 1},
        {label: 2, value: 2},
        {label: 3, value: 3},
        {label: '4+', value: 4},
      ]
    }
  },
  computed: {
    ...mapState(['lead']),
    ...mapGetters(['availableAreas']),
    roomSelected() {
      return Object.keys(this.room).length > 0
    }
  },
  methods: {
    ...mapActions(['addAreaOfConcern']),

    /**
     * [addWindowsToRoom description]
     * @param {[type]} number [description]
     */
    addWindowsToRoom(number) {
      this.$set(this.room, 'windows', number)
    },

    /**
     * [addWindowsThatOpenToRoom description]
     * @param {[type]} number [description]
     */
    addWindowsThatOpenToRoom(number) {
      this.room.windowsThatOpen = number
    },

    /**
     * [selectRoom description]
     * @param  {[type]} room [description]
     * @return {[type]}      [description]
     */
    selectRoom(room) {
      this.room = {...this.room, ...room}
    },

    /**
     * [addRoom description]
     */
    addRoom() {
      this.addAreaOfConcern(this.room)
      this.room = {...this.roomDefault}
      console.log(this.$refs.search)
    }
  },
  mounted() {
    let roomDefault = {...this.room}
    this.$set(this, 'roomDefault', roomDefault)
  }
}
</script>

<style lang="css">
</style>
